module.exports = __webpack_public_path__ + "static/media/art_S3-1.367f452c.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/art_S3-1.png
// module id = 691
// module chunks = 0